import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { roomInitialState } from './constants';
import type { RoomState } from './types';

const roomSlice = createSlice({
  name: 'room',
  initialState: roomInitialState,
  reducers: {
    setRoomUuid: (state, action: PayloadAction<RoomState['roomUuid']>) => {
      state.roomUuid = action.payload;
    },
    setRoomId: (state, action: PayloadAction<RoomState['roomId']>) => {
      state.roomId = action.payload;
    },
    setBamRoomId: (state, action: PayloadAction<RoomState['bamRoomId']>) => {
      state.bamRoomId = action.payload;
    },
    setRoomCountry: (state, action: PayloadAction<RoomState['roomCountry']>) => {
      state.roomCountry = action.payload;
    },
    setRoomName: (state, action: PayloadAction<RoomState['roomName']>) => {
      state.roomName = action.payload;
    },
    resetRoom: (state) => {
      state.roomId = null;
      state.roomUuid = null;
      state.bamRoomId = null;
      state.roomCountry = null;
      state.roomName = null;
    },
  },
});

export const { setRoomUuid, setRoomId, setBamRoomId, setRoomCountry, resetRoom, setRoomName } =
  roomSlice.actions;

export default roomSlice.reducer;
